import { AsyncPipe, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { SavingPlanMostChosenListBase } from '@zero/saving-plans/feature-saving-plans/base';
import { SavingPlanMostChosenItemComponent } from '../saving-plan-most-chosen-item/saving-plan-most-chosen-item.component';

@Component({
  selector: 'saving-plans-saving-plan-most-chosen-list',
  templateUrl: './saving-plan-most-chosen-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SavingPlanMostChosenItemComponent, AsyncPipe, TranslocoPipe, SlicePipe],
})
export class SavingPlanMostChosenListComponent extends SavingPlanMostChosenListBase {
  constructor(public savingplanFacade: SavingsPlanFacade) {
    super(savingplanFacade);
  }
}
